import { useOptionalTourContext } from "../../contexts/TourContext";
import EditCaseTourRunner from "./EditCaseTourRunner";

// No provider means the partner embed is rendering the flow, which gets no tour
const EditCaseTour = () => {
   const hasTourProvider = Boolean(useOptionalTourContext());

   return hasTourProvider ? <EditCaseTourRunner /> : null;
};

export default EditCaseTour;
